export const DEFAULT_MEU_GUIA_TOUR_SOURCE_NAME = 'Visitas Grupo A';

// Cópia estática do campo `meu_guia_tour` do movimento Visitas Grupo A em Produção.
// O botão usa esta lista local e não consulta banco/API a cada clique.
export const DEFAULT_MEU_GUIA_TOUR_STEPS = [
  {
    "tour_id": "tour_1785905664855",
    "icone": "sorriso",
    "titulo": "Vamos começar?",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Seja bem vindo! Bora saber tudo sobre as visitas? Em algumas etapas te faremos saber tudo acerca deste dia. <strong><u>Leia atentamente!</u></strong></span></p>",
    "ordem": 0
  },
  {
    "tour_id": "tour_1785905686967",
    "icone": "presenca",
    "titulo": "Cadastro obrigatório",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Todos os integrantes <strong>deverão estar previamente cadastrados</strong>. Quem ainda não tiver realizado o cadastro precisará entrar na fila para fazê-lo no local e somente depois poderá acessar as dependências da Vila Arens.</span></p>",
    "ordem": 1
  },
  {
    "tour_id": "tour_1785905718140",
    "icone": "horario",
    "titulo": "Chegue cedo!",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Recomendamos que todos <strong>cheguem com antecedência</strong>, pois poderá haver fila para a entrada. A igreja estará aberta para receber os missionários a partir das 07:00.</span></p>",
    "ordem": 2
  },
  {
    "tour_id": "tour_1785905732859",
    "icone": "ajuda",
    "titulo": "Se precisar de ajuda!",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">O guia ou líder do seu grupo <strong>será o principal contato em caso de dúvidas</strong> ou necessidade de ajuda. Caso ele não consiga resolver, procure o Cooperador de Jovens e Menores da sua comum.</span></p>",
    "ordem": 3
  },
  {
    "tour_id": "tour_1785905733309",
    "icone": "sol",
    "titulo": "Roupas confortáveis",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Pedimos que todos os missionários venham com <strong>roupas confortáveis, discretas e adequadas</strong> para a realização das visitas, considerando os deslocamentos e as atividades do dia. Como cristãos, desejamos também refletir, por meio de nossa apresentação, o cuidado, o respeito e o bom testemunho que fazem parte da nossa missão.</span></p>",
    "ordem": 4
  },
  {
    "tour_id": "tour_1785905733450",
    "icone": "agua",
    "titulo": "Garrafinha de água",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Recomendamos que cada missionário <strong>leve uma garrafinha de água para uso pessoal</strong>, mantendo-se hidratado durante as atividades. Ao longo do dia, poderá ser difícil interromper o deslocamento de todo o grupo para buscar água.</span></p>",
    "ordem": 5
  },
  {
    "tour_id": "tour_1785905808996",
    "icone": "refeicoes",
    "titulo": "Refeições",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Na parte inferior da aba “Ingresso”, você encontrará as informações sobre as datas, os horários e os locais das refeições. Como cada grupo possui uma programação diferente, <strong>acompanhe atentamente onde e quando o seu grupo deverá realizar cada refeição</strong>.</span></p>",
    "ordem": 6
  },
  {
    "tour_id": "tour_1785905809138",
    "icone": "carro",
    "titulo": "Estacionamento",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Neste dia, o <strong>estacionamento da Vila Arens estará com a capacidade esgotada</strong>. Por isso, recomendamos que você entre em contato com o guia ou líder do seu grupo para combinar o deslocamento e, sempre que possível, reduzir a quantidade de veículos utilizados.</span></p>",
    "ordem": 7
  },
  {
    "tour_id": "tour_1785905809280",
    "icone": "marco",
    "titulo": "Caronas",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\"><strong>Planeje com antecedência caso precise de carona</strong>. Os Cooperadores de Jovens e Menores são responsáveis por coordenar essa organização junto aos integrantes de cada grupo.</span></p>",
    "ordem": 8
  },
  {
    "tour_id": "tour_1785905809421",
    "icone": "usuarios",
    "titulo": "Organização dos grupos",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">A distribuição dos missionários em cada grupo foi realizada exclusivamente pelo Cooperador de Jovens e Menores. Portanto, qualquer solicitação de alteração deverá ser encaminhada diretamente a ele, pois <strong>somente o Cooperador responsável poderá modificar a composição dos grupos</strong>.</span></p>",
    "ordem": 9
  },
  {
    "tour_id": "tour_1785905809546",
    "icone": "organizacao",
    "titulo": "Tamanho do Grupo",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Os grupos terão no máximo 14 pessoas, podendo ser menores devido às limitações de alguns apartamentos. Apenas os missionários designados deverão participar das visitas, e <strong>nenhum outro participante poderá ser incluído sem a orientação da organização</strong>, evitando constrangimentos às famílias.</span></p>",
    "ordem": 10
  },
  {
    "tour_id": "tour_1785905809680",
    "icone": "rota",
    "titulo": "Logística das visitas",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">O sistema calculou automaticamente a sequência mais eficiente das visitas, considerando distância, tempo de trânsito e outras informações. <strong>Recomendamos que o grupo siga a ordem indicada.</strong></span></p>",
    "ordem": 11
  },
  {
    "tour_id": "tour_1785905809830",
    "icone": "qrcode",
    "titulo": "Ingresso com QRCode",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Cada missionário deverá acessar a Vila Arens com o QR Code disponível na aba <strong>“Ingresso”</strong>. O código é pessoal, intransferível e válido para um único uso. Ao escaneá-lo, sua presença será registrada e seu grupo será informado de que você já chegou ao local.</span></p>",
    "ordem": 12
  },
  {
    "tour_id": "tour_1785905809971",
    "icone": "objetivo",
    "titulo": "Encontro com o grupo",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Se você é o <strong>guia ou líder, será responsável por reunir todo o grupo ao chegar</strong> ao local. Todos os integrantes têm acesso aos contatos uns dos outros; por isso, utilizem essas informações para se comunicar e se encontrar.</span></p>",
    "ordem": 13
  },
  {
    "tour_id": "tour_1785905974164",
    "icone": "usuarios",
    "titulo": "Menu Grupo",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Na aba <strong>“Grupo”</strong>, você poderá visualizar todos os integrantes e suas principais informações, como líder, violeiro e disponibilidade de veículo para carona. Também será possível acompanhar quem já chegou ao local e, ao clicar no número de telefone, iniciar uma conversa pelo WhatsApp.</span></p>",
    "ordem": 14
  },
  {
    "tour_id": "tour_1785905987660",
    "icone": "contato",
    "titulo": "Menu Visitas",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">A aba <strong>“Visitas”</strong> é exclusiva para o guia ou líder do grupo. Nela, ele poderá consultar todas as informações das visitas e registrar se cada uma foi realizada ou não.</span></p>",
    "ordem": 15
  },
  {
    "tour_id": "tour_1785905987818",
    "icone": "novo_usuario",
    "titulo": "Novas visitas",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Durante as visitas, Deus poderá colocar no coração do grupo o desejo de visitar uma família que não esteja previamente cadastrada. Nesse caso, o líder deverá utilizar o botão <strong>“+”</strong>, localizado no topo da aba <strong>“Visitas”</strong>, para adicionar a família. O registro de todas as visitas adicionais é obrigatório.</span></p>",
    "ordem": 16
  },
  {
    "tour_id": "tour_1785949629325",
    "icone": "foto",
    "titulo": "Fotos e Vídeos",
    "descricao_html": "<p>Os <strong>missionários não devem tirar fotos nem fazer filmagens dentro das casas visitadas</strong>. No entanto, caso algum morador da residência decida fotografar ou filmar por iniciativa própria, não há problema e ele não deve ser repreendido.</p>",
    "ordem": 17
  },
  {
    "tour_id": "tour_1785906028135",
    "icone": "calendario",
    "titulo": "Cronograma",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\"><strong>07:00</strong> – Café da manhã</span></p><p><span style=\"color: rgb(0, 0, 0)\"><strong>08:00</strong> – Orientações aos missionários</span></p><p><span style=\"color: rgb(0, 0, 0)\"><strong>09:00</strong> – Início das visitas</span></p><p><span style=\"color: rgb(0, 0, 0)\"><strong>Para almoço consulte o horário do seu grupo</strong></span></p><p><span style=\"color: rgb(0, 0, 0)\"><strong>14:00</strong> – Retorno às visitas</span></p><p><span style=\"color: rgb(0, 0, 0)\"><strong>17:00</strong> – Encerramento das atividades<br /><strong>19:30</strong> – Culto com busca de dons na Vila Arens</span></p>",
    "ordem": 18
  },
  {
    "tour_id": "tour_1785949861348",
    "icone": "whatsapp",
    "titulo": "Comunhão",
    "descricao_html": "<p><span style=\"color: rgb(0, 0, 0)\">Todos devem <strong>manter a comunhão nas casas a serem visitadas</strong>, evitando conversas paralelas e brincadeiras. Durante as visitas, não devem ser feitas perguntas de caráter pessoal às famílias.</span></p><p></p>",
    "ordem": 19
  },
  {
    "tour_id": "tour_1785950080154",
    "icone": "megafone",
    "titulo": "Orações",
    "descricao_html": "<p>Com prudência e comunhão, permitam que o grupo compartilhe o que Deus revelar, <strong>sempre na guia de Deus</strong>. Façam também um <strong>rodízio para conduzir a oração</strong>.</p>",
    "ordem": 20
  },
  {
    "tour_id": "tour_1785950483315",
    "icone": "horario",
    "titulo": "Tempo da visita",
    "descricao_html": "<p>As visitas devem ser conduzidas de forma breve e objetiva, com <strong>duração máxima de 20 minutos</strong>.</p>",
    "ordem": 21
  },
  {
    "tour_id": "tour_1785950807576",
    "icone": "leitura",
    "titulo": "Hinários e Véus",
    "descricao_html": "<p>É fundamental levar <strong>hinários e véus para emprestar</strong> ou, quando necessário, <strong>doar às famílias visitadas</strong>. </p>",
    "ordem": 22
  },
  {
    "tour_id": "tour_1785951008836",
    "icone": "grupo",
    "titulo": "Hinos",
    "descricao_html": "<p>Em todas as visitas os <strong>hinos, de preferência, serão chamados pelos membros da família</strong>.</p>",
    "ordem": 23
  },
  {
    "tour_id": "tour_1785989608389",
    "icone": "musica",
    "titulo": "Instrumentos",
    "descricao_html": "<p>Os instrumentos permitidos são: <strong>violão, violino, viola, flauta, clarinete e escaleta</strong>.</p>",
    "ordem": 24
  },
  {
    "tour_id": "tour_1785906080219",
    "icone": "sorriso",
    "titulo": "Deus abençoe!",
    "descricao_html": "<p>Agradecemos a dedicação de todos. <strong>Que Deus abençoe e conduza cada grupo</strong>, levando alegria e amor a todas as famílias visitadas.</p>",
    "ordem": 25
  }
];

export const DEFAULT_MEU_GUIA_TOUR_DELAY_SECONDS = 0;
export const DEFAULT_MEU_GUIA_PRESENCE_CONFIRMATION_SECONDS = 1;
